import { useEffect, useState } from 'react';

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isTouchDevice =
      'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const mobileUserAgents = [
      /android/,
      /iphone/,
      /ipad/,
      /ipod/,
      /blackberry/,
      /windows phone/,
    ];
    const isUserAgentMobile = mobileUserAgents.some((agent) =>
      userAgent.match(agent),
    );
    setIsMobile(isTouchDevice && isUserAgentMobile);
  }, []);

  return isMobile;
};
